enum FormExtensibleComponents {
    Form,
    Page1Header,
    Page2Header,
    Page3Header,
    Page4Header
}

export { FormExtensibleComponents };
